import { Flame } from "lucide-react";
import { useStreak } from "@/lib/streak";
import { cn } from "@/lib/utils";

const DOW = ["S", "M", "T", "W", "T", "F", "S"];

export const StreakCard = () => {
  const s = useStreak();
  const hot = s.current > 0;
  return (
    <div className={cn("fade-up mb-5 flex flex-wrap items-center gap-4 rounded-2xl border p-4 sm:p-5", hot ? "border-[#D4AF37]/50 bg-gradient-to-r from-[#D4AF37]/15 via-[#141417] to-[#141417]" : "border-[#27272A] bg-[#141417]")} data-testid="streak-card">
      <div className="flex items-center gap-3">
        <span className={cn("relative flex h-12 w-12 items-center justify-center rounded-2xl", hot ? "bg-[#D4AF37] text-black shadow-[0_0_30px_-4px_rgba(212,175,55,0.7)]" : "bg-[#27272A] text-zinc-500")}>
          <Flame className={cn("h-6 w-6", hot && "fill-black/20")} />
        </span>
        <div>
          <div className="flex items-baseline gap-1.5"><span className={cn("font-mono text-3xl font-bold", hot ? "text-[#F3C649]" : "text-zinc-400")} data-testid="streak-count">{s.current}</span><span className="text-sm text-zinc-400">day{s.current === 1 ? "" : "s"} apply streak</span></div>
          <p className="text-xs text-zinc-500" data-testid="streak-hint">{!hot ? "Apply with a tailored resume today to start a streak." : s.today ? "Applied with a tailored resume today. Keep it going tomorrow." : "Apply with a tailored resume today to keep your streak."}</p>
          {s.best > 0 && <p className="mt-0.5 font-mono text-[10px] uppercase tracking-wider text-zinc-600 sm:hidden" data-testid="streak-best-mobile">Best · {s.best} days</p>}
        </div>
      </div>
      <div className="ml-auto flex items-center gap-4">
        <div className="flex gap-1.5" data-testid="streak-week">
          {s.week.map((w) => (
            <div key={w.d} className="flex flex-col items-center gap-1">
              <span className={cn("h-6 w-6 rounded-full border", w.on ? "border-[#D4AF37] bg-[#D4AF37]" : "border-[#3F3F46]")} title={w.d} />
              <span className="font-mono text-[9px] text-zinc-600">{DOW[new Date(`${w.d}T12:00:00`).getDay()]}</span>
            </div>
          ))}
        </div>
        <div className="hidden text-right sm:block"><div className="font-mono text-sm text-zinc-200" data-testid="streak-best">{s.best}</div><div className="text-[10px] uppercase tracking-wider text-zinc-500">Best</div></div>
      </div>
    </div>
  );
};
